export default __webpack_public_path__ + "static/media/onion.88b6a61f.png";